import axios from 'axios';
import { policyDecisionRequestsPayloadType } from 'types/purchaseLicenseModalTypes';

export const postPolicyDecisionGrantRequest = (
  corpAcctNbr: string,
  ssoToken: string,
  payload: policyDecisionRequestsPayloadType,
) => {
  return axios.post(
    '/rest-api/authorization/v1/policyDecisionRequests',
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        'nextiva-context-corpAcctNumber': corpAcctNbr,
        Authorization: `Bearer ${ssoToken}`,
      },
      withCredentials: true,
    },
  );
};
